import $ from "jquery";
import tinymce from 'tinymce';
import { showMessage, initTinymce } from "./main";
import { chunkUploadAndFillForDownloadFields } from "./upload";
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forDownloadDetail")
        return;
    initTinymce('ForDownloadDescription', 300);
    initShowFileSelectModal();
    initUploadFile();
    initSave();
});
function initShowFileSelectModal() {
    $("#selectFile").off('click');
    $('#selectFile').on('click', function () {
        var fileInfo = $('#FileInfo')[0];
        var fileInput = document.getElementById("FileInput");
        // Skryť informáciu o uloženom súbore
        if (fileInfo) {
            fileInfo.style.display = "none";
        }
        // Zobraziť vstup pre nahranie nového súboru
        if (fileInput) {
            fileInput.style.display = "block";
        }
    });
}
function postForm(url, form) {
    tinymce.triggerSave();
    var formData = new FormData(form);
    return $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: function () { $('#spinnerContainer').removeClass('d-none'); },
        complete: function () { $('#spinnerContainer').addClass('d-none'); }
    });
}
function initSave() {
    $("#btnSave").on('click', function () {
        if ($(this).prop("disabled")) {
            return;
        }
        var url = '/ForDownload/Edit';
        var form = $("#formForDownload")[0];
        var fileInput = $('#fileForDownload')[0];
        var file = (fileInput && fileInput.files && fileInput.files.length > 0) ? fileInput.files[0] : null;
        // 1) ak nie je nový súbor → SAVE ako doteraz
        if (!file) {
            var request = postForm(url, form);
            request.done(function (res) {
                if (!res.error)
                    window.location.href = res.redirectUrl;
                else {
                    var editorId = $("#forDownloadTinymceId").val();
                    var ed = tinymce.EditorManager.get(editorId);
                    if (ed)
                        ed.remove();
                    $("#forDownloadDetailBody").html(res.html);
                    initTinymce($("#forDownloadTinymceId").val(), 300);
                    initShowFileSelectModal();
                }
            });
            request.fail(function (jqXHR) { console.error(jqXHR); });
            return;
        }
        // 2) ak je súbor → najprv chunk upload, potom SAVE (bez pripájania file)
        disableSaveButton();
        chunkUploadAndFillForDownloadFields(file, {
            // defaulty sú /admin/uploads/*, takže toto ani nemusíš dávať
            progressBarSelector: "#uploadProgressBar",
            statusSelector: "#uploadStatus"
        }, {
            onDone: function () {
                // TERAZ už máš vyplnené #FileUrl, #FileName, #OriginalFileName
                // a môžeš poslať form normálne cez AJAX (bez file append)
                var request = postForm(url, form);
                request.done(function (res) {
                    enableSaveButton();
                    if (!res.error)
                        window.location.href = res.redirectUrl;
                    else {
                        var editorId = $("#forDownloadTinymceId").val();
                        var ed = tinymce.EditorManager.get(editorId);
                        if (ed)
                            ed.remove();
                        $("#forDownloadDetailBody").html(res.html);
                        initTinymce($("#forDownloadTinymceId").val(), 300);
                        initShowFileSelectModal();
                    }
                });
                request.fail(function (jqXHR) { console.error(jqXHR); });
            },
            onError: function (msg) {
                enableSaveButton();
                showMessage("Upload failed: " + msg, "Chyba!");
            }
        });
    });
}
function initUploadFile() {
    $('#uploadFile').on('click', function () {
        var fileInfo = $('#FileInfo')[0];
        var fileInput = $('#FileInput')[0];
        // Skryť informáciu o uloženom súbore
        if (fileInfo) {
            fileInfo.style.display = "none";
        }
        // Zobraziť vstup pre nahranie nového súboru
        if (fileInput) {
            fileInput.style.display = "block";
        }
    });
}
function disableSaveButton() {
    var $btn = $("#btnSave");
    $btn.prop("disabled", true);
    $btn.addClass("disabled");
    $btn.data("orig-text", $btn.html());
    $btn.html("Uploading...");
}
function enableSaveButton() {
    var $btn = $("#btnSave");
    $btn.prop("disabled", false);
    $btn.removeClass("disabled");
    var origText = $btn.data("orig-text");
    if (origText) {
        $btn.html(origText);
    }
}
//# sourceMappingURL=forDownloadDetail.js.map